var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconamoonProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 30.0002C6.66699 28.2321 7.36937 26.5364 8.61961 25.2861C9.86986 24.0359 11.5655 23.3335 13.3337 23.3335H26.667C28.4351 23.3335 30.1308 24.0359 31.381 25.2861C32.6313 26.5364 33.3337 28.2321 33.3337 30.0002C33.3337 30.8842 32.9825 31.7321 32.3573 32.3572C31.7322 32.9823 30.8844 33.3335 30.0003 33.3335H10.0003C9.11627 33.3335 8.26842 32.9823 7.6433 32.3572C7.01818 31.7321 6.66699 30.8842 6.66699 30.0002Z",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 16.6667C22.7619 16.6667 25.0005 14.4282 25.0005 11.6667C25.0005 8.90532 22.7619 6.66675 20.0005 6.66675C17.2391 6.66675 15.0005 8.90532 15.0005 11.6667C15.0005 14.4282 17.2391 16.6667 20.0005 16.6667Z",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonProfile);
export default __webpack_public_path__ + "static/media/iconamoon_profile.d8351917ca9b1366422ad5da3e81bd91.svg";
export { ForwardRef as ReactComponent };